module.exports = __webpack_public_path__ + "97ccd7225e23bec3322a3b066bff05a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/intro-bg.png
// module id = 858
// module chunks = 3